/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicLoginDTO
 */
export interface PublicLoginDTO {
  /**
   *
   * @type {string}
   * @memberof PublicLoginDTO
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof PublicLoginDTO
   */
  eanToLike?: string;
  /**
   *
   * @type {number}
   * @memberof PublicLoginDTO
   */
  platformId: number;
}

/**
 * Check if a given object implements the PublicLoginDTO interface.
 */
export function instanceOfPublicLoginDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "email" in value;
  isInstance = isInstance && "platformId" in value;

  return isInstance;
}

export function PublicLoginDTOFromJSON(json: any): PublicLoginDTO {
  return PublicLoginDTOFromJSONTyped(json, false);
}

export function PublicLoginDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublicLoginDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    email: json["email"],
    eanToLike: !exists(json, "eanToLike") ? undefined : json["eanToLike"],
    platformId: json["platformId"]
  };
}

export function PublicLoginDTOToJSON(value?: PublicLoginDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    email: value.email,
    eanToLike: value.eanToLike,
    platformId: value.platformId
  };
}
